import {TaxSummary as TaxSummaryV1, PriceSummary as PriceSummaryV1} from '@wix/auto_sdk_ecom_current-cart';
import {V2TaxSummary as TaxSummary} from '@wix/auto_sdk_ecom_cart-v-2';
import {TaxModel} from './Tax.model';
import {ModelContext} from '../../../types/app.types';

export class TaxSummaryModel {
  public taxes: TaxModel[];

  constructor(params: TaxSummaryModel) {
    this.taxes = params.taxes;
  }

  public static fromCartV1(
    taxSummary: TaxSummaryV1 | undefined,
    priceSummary: PriceSummaryV1 | undefined,
    modelContext: ModelContext
  ) {
    return new TaxSummaryModel({
      taxes: [
        TaxModel.fromCartV1(
          {
            name: taxSummary?.taxName ?? '',
            amount: priceSummary?.tax,
          },
          modelContext
        ),
      ],
    });
  }

  public static fromCartV2(taxSummary: TaxSummary, modelContext: ModelContext): TaxSummaryModel {
    return new TaxSummaryModel({
      taxes: taxSummary.taxes?.map((tax) => TaxModel.fromCartV2(tax, modelContext)),
    });
  }
}
